import React from "react";

const XPerimeterSvg = (props) => (
  <svg
    style={{ margin: "0px", padding: "0px", width: "800px", height: "425px" }}
  >
    <svg
      width="1000px"
      height="1000px"
      id="ICONS"
      version="1.1"
      viewBox="0 0 1000 1000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        stroke={props.rectColor}
        stroke-width="1"
        d="M 200 2 L 200 80, 2 80,2 340, 200 340, 200 420, 600 420,600 340, 795 340, 795 80, 600 80, 600 2Z"
      />
    </svg>
  </svg>
);
export default XPerimeterSvg;
